import React from 'react';
import { graphql, Link as GLink, useStaticQuery } from 'gatsby';
import Sticky from 'react-sticky-el';
import { Box, Container, css, Flex } from 'theme-ui';
import { normalizeBlockContentNodes } from '@blocks-helpers';
import ContentImages from '@solid-ui-components/ContentImages';
import ContentButtons from '@solid-ui-components/ContentButtons';
import './styles.css';
import { styles } from './styles';
import Drawer from '@solid-ui-components/Drawer';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';

const {
  wrapper,
  header,
  buttonsContainer,
  buttonsWrapper,
  logoContainer,
  mobileHeaderLogo,
  mobileMenu,
  desktopMenu,
  desktopMenuContainer,
  headerButtons,
} = styles;

const HeaderBlock01 = () => {
  const { allBlockContent } = useStaticQuery(query);
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);
  const { images, collection } = content[`header-common`];
  return (
    <>
      <Sticky stickyClassName='nav-sticky' css={css(wrapper)}>
        <Container variant='header' className='nav-container'>
          <Flex sx={header}>
            <Box sx={logoContainer}>
              <GLink to='/'>
                <ContentImages content={{ images }} imageEffect='fadeIn' />
              </GLink>
            </Box>
            {collection && (
              <>
                <Box sx={desktopMenu}>
                  <Flex sx={desktopMenuContainer}>
                    {collection.map(
                      ({ buttons }, index) =>
                        buttons && (
                          <Box key={`item-${index}`} sx={buttonsContainer}>
                            <ContentButtons
                              content={buttons}
                              wrapperStyles={buttonsWrapper}
                            />
                          </Box>
                        )
                    )}
                  </Flex>
                </Box>
                <Box sx={mobileMenu}>
                  <Drawer buttonStyle={{ svg: { size: 28 } }}>
                    <Box sx={mobileHeaderLogo}>
                      <Box sx={logoContainer}>
                        <GLink to='/'>
                          <ContentImages
                            content={{ images }}
                            imageEffect='fadeIn'
                          />
                        </GLink>
                      </Box>
                    </Box>
                    {collection.map(
                      ({ buttons }, index) =>
                        buttons && (
                          <Box key={`item-${index}`} sx={headerButtons}>
                            <ContentButtons
                              content={buttons}
                              variant='vertical'
                            />
                          </Box>
                        )
                    )}
                  </Drawer>
                </Box>
              </>
            )}
          </Flex>
        </Container>
      </Sticky>
    </>
  );
};

export const query = graphql`
  query HeaderEnBlockContent {
    allBlockContent(
      filter: { page: { in: ["targpatrol-en/index", "shared"] } }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`;

export default WithDefaultContent(HeaderBlock01);
